module.exports = __webpack_public_path__ + "assets/3e105ba8c7a52aabfb63ba96c519c3b2.mp3";